// extracted by mini-css-extract-plugin
export default {"container":"Story_container__XYJII","top":"Story_top__BLfBX","story":"Story_story__Nww49","pictures":"Story_pictures__7rRnU","lots":"Story_lots__MUH45"};